import * as React from 'react';
import { SVGProps } from 'react';

const SvgStrengthening = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M11.908 26.895H9.67v-14.27h2.237v14.27Zm-4.164-1.428H5.817V14.112h1.927v11.355Zm-3.921-1.451H2v-8.667h1.823v8.667Zm26.505 3.05h-2.236v-14.27h2.236v14.27Zm3.855-1.486h-1.928V14.224h1.928V25.58Zm3.812-9.905.004 8.667h-1.828v-8.666h1.824Z"
    />
    <path fill={props.fill} d="M29.43 20.635H12.02v-2.56h15.052l2.358 2.56Z" />
  </svg>
);

export default SvgStrengthening;
